import { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";

/**
 * Componente Portal para renderizar modales fuera de la jerarquía del DOM
 * Garantiza que los modales se muestren por encima de todo el contenido
 * Crea un contenedor dedicado directamente en el body
 */
const ModalPortal = ({ children, isOpen }) => {
  const [mounted, setMounted] = useState(false);
  const portalRoot = useRef(null);

  useEffect(() => {
    // Crear o obtener el contenedor de modales
    let modalContainer = document.getElementById("modal-root");

    if (!modalContainer) {
      modalContainer = document.createElement("div");
      modalContainer.id = "modal-root";
      modalContainer.style.position = "fixed";
      modalContainer.style.top = "0";
      modalContainer.style.left = "0";
      modalContainer.style.width = "100%";
      modalContainer.style.height = "100%";
      modalContainer.style.pointerEvents = "none";
      modalContainer.style.zIndex = "99999999";
      document.body.appendChild(modalContainer);
    }

    portalRoot.current = modalContainer;
    setMounted(true);

    return () => {
      // No remover el contenedor, puede ser usado por otros modales
    };
  }, []);

  // Solo renderizar si está montado y abierto
  if (!mounted || !isOpen || !portalRoot.current) return null;

  // Crear el portal en el contenedor dedicado
  return createPortal(
    <div style={{ pointerEvents: "auto" }}>{children}</div>,
    portalRoot.current
  );
};

export default ModalPortal;
